import React, { useState, useEffect } from "react";
import "./ProcessorQCTable.scss";
import { styled } from "@mui/material/styles";
import {
  Grid,
  Box,
  // SvgIcon,
  Tab,
  Tabs,
  FormControl,
  Select,
  MenuItem,
  Snackbar,
  Alert,
  AlertTitle,
  IconButton,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { useDispatch, useSelector } from "react-redux";
import Label from "../../Label/Label";
import moment from "moment";
import {
  // getProDataForReset,
  isSignatureUploaded,
  pageRedirection,
  qcDataEntry,
  qcReInitiateProVlm,
  rejectData,
  setOCRValue,
  setSelectedFileDataForProUpdateMapping,
} from "../../../redux/processor/actions";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Authentication from "../../../components/Modal/PopupModal/PopupModal";
import ModalSign from "../../../components/Modal/Signature/ModalSign";
import QCRowRejectAndReviewNew from "../TemplateDriven/QCRowRejectAndReviewNew";
import NewQuestion from "./NewQuestion";
import QCEditableCell from "./QCEditableCell";
import QCComment from "../TemplateDriven/QCComment";
import ReInitiateVlmCheckbox from "../TemplateDriven/ReInitiateVlmCheckbox";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { logObject } from "../../../config/logs";
import ProcessorValueEditableCell from "./ProcessorValueEditableCell";
import DataTypeSelector from "../TemplateDriven/DataTypeSelector";
import RangeSelector from "../TemplateDriven/RangeSelector";
import Validation from "../TemplateDriven/Validation";
import CellMenu from "../TemplateDriven/CellMenu";
import { isDisable } from "../TemplateDriven/EditableCellConfig";
import ClearIcon from "@mui/icons-material/Clear";

// Styled Paper component
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? "#1A2027" : "var(--bg-white)",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export const ProcessorQCTable = React.forwardRef((props, ref) => {
  const {
    // qcTemplateData,
    role,
    showParameterTable,
    assignToValidator,
    // selectedFile
  } = props;

  // console.log(selectedFile)

  const roleMapping = {
    preProcessor: "prePro",
    processor: "pro",
    validator: "vali",
  };

  // const useRejectionCounts = (role, rejectionType) => {
  //   const roleKey = roleMapping[role];

  //   return useSelector(
  //     (state) =>
  //       state?.[roleKey]?.coorData?.mapping_details?.[
  //         `${rejectionType}RejectionCounts`
  //       ] || 0
  //   );
  // };

  const dispatch = useDispatch();
  const qcTemplateData = useSelector(
    (state) => state?.pro?.coorData?.mapping_details?.parametersData || []
  );

  const reProcessEntireBatch = useSelector(
    (state) => state.pro?.coorData?.mapping_details?.reProcessEntireBatch
  );

  const reProcess = useSelector(
    (state) => state?.pro?.coorData?.mapping_details?.reProcess || false
  );

  const selectedFilesDataForProUpdate = useSelector(
    (state) => state?.pro?.selectedFilesDataForProUpdate
  );

  const bindOcrValuesAndCoords = useSelector(
    (state) => state?.pro?.bindOcrValuesAndCoords
  );

  const [parametersData, setParametersData] = useState([]);
  // const [sortOrder, setSortOrder] = useState({
  //   column: null,
  //   direction: "asc",
  // }); // State to track sort order

  const anyOperationPerformedOnEntirePage = React.useRef(false);

  const [columnWidths, setColumnWidths] = useState({
    sr: 20,
    parameter: 240,
    singleRowInput: 100,
    // input: 90,
    // input2: 30,
    input3: 50,
    input4: 70,
    input5: 70,
    input6: 60,
    // input7: 120,
    input8: 120,
    valiRejection: 95,
    dataType: 100,
    range: 90,
  });
  const [openAuth, setOpenAuth] = useState(false);
  const signUploaded = useSelector((state) => state?.pro?.isSignatureUploaded);
  const reProcessVlmCountsFromAPi = useSelector(
    (state) => state?.pro?.coorData?.mapping_details?.reProcessVlmCounts || 0
  );
  const [openSignPad, setOpenSignPad] = useState(false);
  const [actionAndAutoSave, setActionAndAutoSave] = useState({
    action: "",
    autoSave: "",
  });

  // the below rejection count logic is removed from other branches as its not required, but only kept and used this is in qc branch to enable/disable reprocess menu in cell
  // const [processorsRejectionCounts, setProcessorsRejectionCounts] = useState(
  //   useRejectionCounts(role, "processors")
  // );
  const [rejectedCount, setRejectedCount] = useState(0);

  const [isUpdateParameters, setIsUpdateParameters] = useState(false);
  // Handling window unload

  const [reProcessVlmCounts, setReProcessVlmCounts] = useState(
    reProcessVlmCountsFromAPi || 0
  );

  // const [rowRejectionData, setRowRejectionData] = useState([]);

  const isDataRejectedByValidator = useSelector(
    (state) => state.pro?.coorData?.mapping_details?.isDataRejectedByValidator
  );

  const entireBatchRejectedByVali = useSelector(
    (state) => state?.pro?.coorData?.mapping_details?.entireBatchRejectedByVali
  );

  const coordinatesData = useSelector((state) => {
    return state?.pro?.coorData?.coordinatesDetails;
  });

  const [isAlert, setAlert] = useState({
    open: false,
    message: "",
    title: "",
  });

  const [sortOrder, setSortOrder] = useState({
    column: "",
    order: ["Not Sure", "Yes", "No"], // Default sort order
  });

  const [logs, setLogs] = useState([]);
  const [cellToUpdate, setCellToUpdate] = useState({
    parameterIndex: null,
    mappingIndex: null,
  });

  useEffect(() => {
    dispatch(isSignatureUploaded());

    window.addEventListener("beforeunload", beforeunloadFunc);

    return () => {
      window.removeEventListener("beforeunload", beforeunloadFunc);
    };
  }, []);

  useEffect(() => {
    if (qcTemplateData?.length) {
      // const dataWithUUIDAndIndex = qcTemplateData.map((item, index) => ({
      //   ...item,
      //   index: index,
      // }));
      // setParametersData(dataWithUUIDAndIndex);
      setParametersData(qcTemplateData);
    }
  }, [qcTemplateData]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //   callMapData2("save", true); // Pass autosave=true here
  //   }, 120000);

  //   // Cleanup function to clear the interval if the component unmounts or if the repetition is no longer needed
  //   return () => clearInterval(intervalId);
  // }, []); // Empty dependency array ensures the effect runs only once after the component mounts

  // the below logic is used in pro role to acheive cnc
  useEffect(() => {
    if (bindOcrValuesAndCoords?.value && bindOcrValuesAndCoords?.coords) {
      updateCell(bindOcrValuesAndCoords);
      dispatch(setOCRValue());

      if (!anyOperationPerformedOnEntirePage.current) {
        anyOperationPerformedOnEntirePage.current = true;
      }
    }
  }, [bindOcrValuesAndCoords]);

  const updateCell = (bindOcrValuesAndCoords) => {
    const parameterIndex = cellToUpdate?.parameterIndex;
    const mappingIndex = cellToUpdate?.mappingIndex;
    if (
      bindOcrValuesAndCoords?.value &&
      bindOcrValuesAndCoords?.coords &&
      parameterIndex !== null &&
      parameterIndex >= 0 &&
      mappingIndex !== null &&
      mappingIndex >= 0 &&
      parametersData
    ) {
      var transformedHashToNumber = bindOcrValuesAndCoords?.value?.replace(
        "#",
        "Number"
      );

      if (
        parametersData[parameterIndex].mappings[mappingIndex] &&
        transformedHashToNumber !== ""
      ) {
        var transformedValue =
          `${parametersData[parameterIndex].mappings[mappingIndex]?.value} ${transformedHashToNumber}`.trim();
      } else {
        transformedValue = `${transformedHashToNumber}`.trim();
      }

      parametersData[parameterIndex].mappings[mappingIndex] = {
        ...parametersData[parameterIndex].mappings[mappingIndex],
        value: transformedValue,
        coordinates:
          parametersData[parameterIndex].mappings[mappingIndex]?.coordinates &&
          parametersData[parameterIndex].mappings[mappingIndex]?.coordinates
            ?.length >= 0
            ? [
                ...parametersData[parameterIndex].mappings[mappingIndex]
                  ?.coordinates,
                bindOcrValuesAndCoords?.coords,
              ]
            : [bindOcrValuesAndCoords?.coords],

        coordinatesValues:
          parametersData[parameterIndex].mappings[mappingIndex]
            ?.coordinatesValues &&
          parametersData[parameterIndex].mappings[mappingIndex]
            ?.coordinatesValues?.length >= 0
            ? [
                ...parametersData[parameterIndex].mappings[mappingIndex]
                  ?.coordinatesValues,
                bindOcrValuesAndCoords?.value,
              ]
            : [bindOcrValuesAndCoords?.value],

        processor: localStorage.userRole,
        processedDate: moment(new Date()).format("DD-MMM-YYYY"),
      };

      // in pro added page details for unmapped page by pre
      if (
        parametersData[parameterIndex].mappings[mappingIndex]?.pageNo === "" &&
        parametersData[parameterIndex].mappings[mappingIndex]?.tagName === ""
      ) {
        parametersData[parameterIndex].mappings[mappingIndex] = {
          ...parametersData[parameterIndex].mappings[mappingIndex],
          fileNo: selectedFilesDataForProUpdate?.fileNo,
          pageNo: selectedFilesDataForProUpdate?.pageNo,
          tagName: selectedFilesDataForProUpdate?.tagName,
          lockedPreTagName: selectedFilesDataForProUpdate?.tagName,
          lockedPrePageNo: selectedFilesDataForProUpdate?.pageNo,
          lockedPreFileNo: selectedFilesDataForProUpdate?.fileNo,
          forNoPreProMappingDataEntryByPro: true,
        };
      }
      setParametersData([...parametersData]);
    }
  };

  React.useImperativeHandle(ref, () => ({
    mapData2: (action, rejectionRemark, batchRejection, autoSave) => {
      setActionAndAutoSave({
        action: action,
        autoSave: autoSave,
      });

      if (autoSave === false && action === "saveAndNext") {
        // const containsNotSure = parametersData.some((item) =>
        //   item.mappings.some((mapping) => mapping.response === "Not Sure")
        // );

        // if (containsNotSure) {
        //   setAlert({
        //     ...isAlert,
        //     open: true,
        //     message:
        //       "One or more responses are 'Not Sure'. Please resolve before proceeding.",
        //     title: "Processing Error",
        //   });

        //   // alert(
        //   //   "One or more responses are 'Not Sure'. Please resolve before proceeding."
        //   // );
        //   return; // Exit the function if 'Not Sure' exists
        // } else {
        if (signUploaded?.isSignatureUploaded !== undefined) {
          if (signUploaded?.isSignatureUploaded === true) {
            // const isAssignForValidator = process.env.REACT_APP_VALIDATOR_FOR_QC;
            // if (isAssignForValidator === "true") {
            if (assignToValidator) {
              const containsNotSure = parametersData.some((item) =>
                item.mappings.some((mapping) => mapping.response === "Not Sure")
              );

              if (containsNotSure) {
                setAlert({
                  ...isAlert,
                  open: true,
                  message:
                    "One or more responses are 'Not Sure'. Please resolve before proceeding.",
                  title: "Processing Error",
                });

                // alert(
                //   "One or more responses are 'Not Sure'. Please resolve before proceeding."
                // );
                return; // Exit the function if 'Not Sure' exists
              } else {
                callMapData2({
                  action,
                  rejectionRemark,
                  batchRejection,
                  autoSave,
                });
              }
            } else {
              setOpenAuth(true);
            }
          } else if (signUploaded?.isSignatureUploaded === false) {
            setOpenSignPad(true);
          }
        }
        // }
      } else {
        callMapData2({ action, rejectionRemark, batchRejection, autoSave });
      }
    },
  }));

  const callMapData2 = ({
    action,
    rejectionRemark,
    batchRejection,
    autoSave,
  }) => {
    if (action !== "save") {
      if (rejectedCount >= 1) {
        action = "reject";
      }
    }
    const next = action === "saveAndNext" ? true : false;

    if (role === "processor") {
      if (action === "reject") {
        // const updatedParametersData = parametersData.map((item) => {
        //   if (item?.enableCellsForNewColumn === true) {
        //     return {
        //       ...item,
        //       enableCellsForNewColumn: false,
        //     };
        //   }
        //   return item;
        // });

        dispatch(
          rejectData({
            parametersData: parametersData,
            batch_id: localStorage.batchId,
            next: true,
            extractionType: "free_form",
            ...(isDataRejectedByValidator && {
              isDataRejectedByValidator: true,
            }),
            rejection_remark: rejectionRemark,
            isDataRejectedByProcessor: true,
            projectId: localStorage.projectId,
            entireBatchRejectedByPro: batchRejection === true ? true : false,
            ...(entireBatchRejectedByVali && {
              entireBatchRejectedByVali: true,
            }),
            logs: logs,
            // processorsRejectionCounts: processorsRejectionCounts,
            // validatorsRejectionCounts: validatorsRejectionCounts,
            autoSave,
            drug_type: localStorage.getItem("drugType"),
            project_name: localStorage.getItem("projectName"),
            // partial_data_entry: action === "save" ? true : false,
            isUpdateParameters: isUpdateParameters,
          })
        );
      } else if (action === "save") {
        dispatch(
          qcDataEntry({
            parametersData: parametersData,
            projectId: localStorage.projectId,
            batch_id: localStorage.batchId,
            next: next,
            // extractionType: extractionType,
            ...(isDataRejectedByValidator && {
              isDataRejectedByValidator: true,
            }),
            partial_data_entry: true,
            ...(entireBatchRejectedByVali && {
              entireBatchRejectedByVali: true,
            }),
            //  newly added  // below two flag used in 1.3 but as its not accessed throught pro store may be this flags are not useful so commented
            // ...(isDataRejectedByProcessor && {
            //   isDataRejectedByProcessor: true,
            // }),
            // ...(isDataRejectedByProcessor && {
            //   reProcess: true,
            // }),
            ...(reProcessEntireBatch && {
              reProcessEntireBatch: true,
            }),
            logs: logs,
            // processorsRejectionCounts: processorsRejectionCounts,
            // validatorsRejectionCounts: validatorsRejectionCounts,
            autoSave,
            drug_type: localStorage.getItem("drugType"),
            project_name: localStorage.getItem("projectName"),
            isUpdateParameters: isUpdateParameters,
            reProcessVlmCounts: reProcessVlmCounts,
            onSaveSuccess: () => {
              setLogs([]); // Clear logs after debugging
            },
          })
        );
        // setLogs([]); // clearing logs because if user click saveAndNext then also previous log will pass to api so to avoid duplication need to clear logs
      } else if (action === "saveAndNext") {
        // if (validatorsRejectionCounts) {
        const rejectionFound = parametersData?.some((item) => {
          if (
            item?.mappings?.some(
              (mapping) => mapping?.validatorCellRejection?.isRejected === true
            )
          ) {
            return true; // Stop iteration
          }

          // if (item?.validatorRowRejection?.isRejected === true) {
          //   return true; // Stop iteration
          // }

          return false; // Continue checking other items
        });

        if (rejectionFound) {
          setAlert({
            ...isAlert,
            open: true,
            message:
              "Some rejection are not resolved. please resolve them before continue.",
            title: "Resolve Rejections",
          });
        } else {
          // const updatedParametersData = parametersData.map((item) => {
          //   if (item?.enableCellsForNewColumn === true) {
          //     return {
          //       ...item,
          //       enableCellsForNewColumn: false,
          //     };
          //   }
          //   return item;
          // });

          // Check if any parameter contains `reInitiateProVlm = true`
          const isReInitiateProVlmForBatchRequired = parametersData.some(
            (parameterData) =>
              parameterData.mappings.some(
                (mapping) => mapping.reInitiateProVlm === true
              )
          );
          if (isReInitiateProVlmForBatchRequired) {
            dispatch(
              qcReInitiateProVlm({
                parametersData: parametersData,
                projectId: localStorage.projectId,
                batch_id: localStorage.batchId,
                next: next,
                // extractionType: extractionType,
                // ...(isDataRejectedByValidator && {
                //   reValidate: true,
                // }),
                // ...(isDataRejectedByValidator && {
                //   isDataRejectedByValidator: true,
                // }),
                partial_data_entry: false,
                entireBatchRejectedByVali: false,
                // ...(entireBatchRejectedByVali && {
                //   reValidateEntireBatch: true,
                // }),
                logs: logs,
                // processorsRejectionCounts: processorsRejectionCounts,
                // validatorsRejectionCounts: validatorsRejectionCounts,
                autoSave,
                drug_type: localStorage.getItem("drugType"),
                project_name: localStorage.getItem("projectName"),
                isUpdateParameters: isUpdateParameters,
              })
            );
          } else {
            const containsNotSure = parametersData.some((item) =>
              item.mappings.some((mapping) => mapping.response === "Not Sure")
            );

            if (containsNotSure) {
              setAlert({
                ...isAlert,
                open: true,
                message:
                  "One or more responses are 'Not Sure'. Please resolve before proceeding.",
                title: "Processing Error",
              });

              // alert(
              //   "One or more responses are 'Not Sure'. Please resolve before proceeding."
              // );
              return; // Exit the function if 'Not Sure' exists
            } else {
              dispatch(
                qcDataEntry({
                  parametersData: parametersData,
                  projectId: localStorage.projectId,
                  batch_id: localStorage.batchId,
                  next: next,
                  extractionType: "free_form",
                  ...(isDataRejectedByValidator && {
                    reValidate: true,
                  }),
                  ...(isDataRejectedByValidator && {
                    isDataRejectedByValidator: true,
                  }),
                  partial_data_entry: false,
                  entireBatchRejectedByVali: false,
                  ...(entireBatchRejectedByVali && {
                    reValidateEntireBatch: true,
                  }),
                  logs: logs,
                  // processorsRejectionCounts: processorsRejectionCounts,
                  // validatorsRejectionCounts: validatorsRejectionCounts,
                  autoSave,
                  drug_type: localStorage.getItem("drugType"),
                  project_name: localStorage.getItem("projectName"),
                  isUpdateParameters: isUpdateParameters,
                  assignToValidator,
                  // onSaveSuccess: () => {
                  //   setLogs([]); // Clear logs after debugging
                  // },
                })
              );
            }
          }
          // setLogs([]); // clearing logs because if user click saveAndNext then also previous log will pass to api so to avoid duplication need to clear logs
        }
      }
    }

    // dispatch(
    //   qcDataEntry({
    //     parametersData: parametersData,
    //     projectId: localStorage.projectId,
    //     next: action === "save" ? false : true,
    //     autosave: autoSave,
    //     isUpdateParameters: false,
    //     logs: [],
    //     drug_type: localStorage.getItem("drugType"),
    //     project_name: localStorage.getItem("projectName"),
    //     partial_data_entry: action === "save" ? true : false,
    //     batch_id: localStorage.getItem("batchId"),
    //   })
    // );
  };

  const beforeunloadFunc = (e) => {
    if (anyOperationPerformedOnEntirePage.current) {
      e.preventDefault();
      e.returnValue = true;
    }
  };
  const handleSort = (column) => {
    // Define the three custom sort orders
    const sortOrders = [
      ["Not Sure", "Yes", "No"], // First click
      ["Yes", "No", "Not Sure"], // Second click
      ["No", "Not Sure", "Yes"], // Third click
    ];

    // Determine the next sort order index
    const currentIndex = sortOrders.findIndex(
      (order) => JSON.stringify(order) === JSON.stringify(sortOrder.order)
    );
    const nextIndex = (currentIndex + 1) % sortOrders.length;
    const nextOrder = sortOrders[nextIndex];

    // Sort the data based on the next order
    const responseOrder = nextOrder.reduce((acc, response, index) => {
      acc[response] = index; // Map responses to their position in the order
      return acc;
    }, {});

    const sortedData = [...parametersData].sort((a, b) => {
      const aValue = responseOrder[a.mappings[0].response] ?? -1;
      const bValue = responseOrder[b.mappings[0].response] ?? -1;
      return aValue - bValue; // Always sort in ascending order based on the current order
    });

    // Update state with the sorted data and next sort order
    setParametersData(sortedData);
    setSortOrder({ column, order: nextOrder });
  };

  // Sorting logic for true and false only
  // const handleSort = (column) => {
  //   let direction = "asc";
  //   if (sortOrder.column === column && sortOrder.direction === "asc") {
  //     direction = "desc";
  //   }

  //   const sortedData = [...parametersData].sort((a, b) => {
  //     const aValue =
  //       a.mappings[0].response === "Yes"
  //         ? 1
  //         : a.mappings[0].response === "No"
  //         ? 0
  //         : a.mappings[0].response === "Not Sure"
  //         ? 2
  //         : -1;

  //     const bValue =
  //       b.mappings[0].response === "Yes"
  //         ? 1
  //         : b.mappings[0].response === "No"
  //         ? 0
  //         : b.mappings[0].response === "Not Sure"
  //         ? 2
  //         : -1;

  //     if (column === "yes") {
  //       // Sorting for "Yes" column: true -> false
  //       if (direction === "asc") {
  //         return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
  //       } else {
  //         return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
  //       }
  //     } else if (column === "no") {
  //       // Sorting for "No" column: false -> true
  //       if (direction === "asc") {
  //         return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
  //       } else {
  //         return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
  //       }
  //     } else if (column === "not_sure") {
  //       // Sorting for "Not Sure" column
  //       if (direction === "asc") {
  //         return aValue === 2 && bValue !== 2
  //           ? -1
  //           : aValue !== 2 && bValue === 2
  //           ? 1
  //           : 0;
  //       } else {
  //         return aValue !== 2 && bValue === 2
  //           ? -1
  //           : aValue === 2 && bValue !== 2
  //           ? 1
  //           : 0;
  //       }
  //     }

  //     return 0; // Default return if no sorting
  //   });

  //   setParametersData(sortedData);
  //   setSortOrder({ column, direction });
  // };

  const handleTrueCheckboxChange = (parameterIndex) => {
    const updatedParametersData = [...parametersData];
    updatedParametersData[parameterIndex] = {
      ...updatedParametersData[parameterIndex],
      mappings: [
        {
          ...updatedParametersData[parameterIndex].mappings[0],
          response: "Yes",
          processor: localStorage?.userName,
          processedDate: moment().format("DD-MMM-YYYY"),

          // updating/setting mapping for unmapped question, this logic is different as have in 1.3 or in parameter exraction
          fileNo:
            updatedParametersData[parameterIndex].mappings[0].fileNo ||
            selectedFilesDataForProUpdate?.fileNo,
          pageNo:
            updatedParametersData[parameterIndex].mappings[0].pageNo ||
            selectedFilesDataForProUpdate?.pageNo,
          tagName:
            updatedParametersData[parameterIndex].mappings[0].tagName ||
            selectedFilesDataForProUpdate?.tagName,
          lockedPreTagName:
            updatedParametersData[parameterIndex].mappings[0].tagName ||
            selectedFilesDataForProUpdate?.tagName,
          lockedPrePageNo:
            updatedParametersData[parameterIndex].mappings[0].pageNo ||
            selectedFilesDataForProUpdate?.pageNo,
          lockedPreFileNo:
            updatedParametersData[parameterIndex].mappings[0].fileNo ||
            selectedFilesDataForProUpdate?.fileNo,
          forNoPreProMappingDataEntryByPro: true,
        },
      ],
    };
    setParametersData(updatedParametersData);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
  };

  const handleFalseCheckboxChange = (parameterIndex) => {
    const updatedParametersData = [...parametersData];
    updatedParametersData[parameterIndex] = {
      ...updatedParametersData[parameterIndex],
      mappings: [
        {
          ...updatedParametersData[parameterIndex].mappings[0],
          response: "No",
          processor: localStorage?.userName,
          processedDate: moment().format("DD-MMM-YYYY"),

          // updating/setting mapping for unmapped question, this logic is different as have in 1.3 or in parameter exraction
          fileNo:
            updatedParametersData[parameterIndex].mappings[0].fileNo ||
            selectedFilesDataForProUpdate?.fileNo,
          pageNo:
            updatedParametersData[parameterIndex].mappings[0].pageNo ||
            selectedFilesDataForProUpdate?.pageNo,
          tagName:
            updatedParametersData[parameterIndex].mappings[0].tagName ||
            selectedFilesDataForProUpdate?.tagName,
          lockedPreTagName:
            updatedParametersData[parameterIndex].mappings[0].tagName ||
            selectedFilesDataForProUpdate?.tagName,
          lockedPrePageNo:
            updatedParametersData[parameterIndex].mappings[0].pageNo ||
            selectedFilesDataForProUpdate?.pageNo,
          lockedPreFileNo:
            updatedParametersData[parameterIndex].mappings[0].fileNo ||
            selectedFilesDataForProUpdate?.fileNo,
          forNoPreProMappingDataEntryByPro: true,
        },
      ],
      // response: false,
    };
    setParametersData(updatedParametersData);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
  };

  // const handleNotSureCheckboxChange = (parameterIndex) => {
  //   const updatedParametersData = [...parametersData];
  //   updatedParametersData[parameterIndex] = {
  //     ...updatedParametersData[parameterIndex],
  //     mappings: [
  //       {
  //         ...updatedParametersData[parameterIndex].mappings[0],
  //         response: "Not Sure",
  //         processor: localStorage?.userName,
  //         processedDate: moment().format("DD-MMM-YYYY"),

  //         // updating/setting mapping for unmapped question, this logic is different as have in 1.3 or in parameter exraction
  //         fileNo:
  //           updatedParametersData[parameterIndex].mappings[0].fileNo ||
  //           selectedFilesDataForProUpdate?.fileNo,
  //         pageNo:
  //           updatedParametersData[parameterIndex].mappings[0].pageNo ||
  //           selectedFilesDataForProUpdate?.pageNo,
  //         tagName:
  //           updatedParametersData[parameterIndex].mappings[0].tagName ||
  //           selectedFilesDataForProUpdate?.tagName,
  //         lockedPreTagName:
  //           updatedParametersData[parameterIndex].mappings[0].tagName ||
  //           selectedFilesDataForProUpdate?.tagName,
  //         lockedPrePageNo:
  //           updatedParametersData[parameterIndex].mappings[0].pageNo ||
  //           selectedFilesDataForProUpdate?.pageNo,
  //         lockedPreFileNo:
  //           updatedParametersData[parameterIndex].mappings[0].fileNo ||
  //           selectedFilesDataForProUpdate?.fileNo,
  //         forNoPreProMappingDataEntryByPro: true,
  //       },
  //     ],
  //     // response: false,
  //   };
  //   setParametersData(updatedParametersData);
  //   if (!anyOperationPerformedOnEntirePage.current) {
  //     anyOperationPerformedOnEntirePage.current = true;
  //   }
  // };

  // Function to handle column resizing
  const handleResize = (column, newWidth) => {
    setColumnWidths((prevWidths) => ({ ...prevWidths, [column]: newWidth }));
  };

  const handleMouseDown = (column) => (event) => {
    event.preventDefault();
    const initialX = event.clientX;
    const initialWidth = columnWidths[column];
    const handleMouseMove = (moveEvent) => {
      const deltaX = moveEvent.clientX - initialX;
      const newWidth = Math.max(25, initialWidth + deltaX);
      handleResize(column, newWidth);
    };
    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.body.classList.remove("resizing");
    };
    document.body.classList.add("resizing");
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const onClickCellToRedirect = ({
    e,
    tagName,
    pageNo,
    fileNo,
    parameterIndex,
    mappingIndex,
    coordinates,
    isDisabled,
    actualPageNumber,
  }) => {
    if (
      actualPageNumber !== "" &&
      actualPageNumber >= 0 &&
      fileNo !== "" &&
      parseInt(fileNo) >= 0 &&
      tagName !== ""
    ) {
      // if (pageNo !== "" && pageNo >= 0) {
      dispatch(pageRedirection({ fileNo, tagName, pageNo: actualPageNumber })); // in processor the page may shift so passing actualPageNumber as pageNo because pageNo is used in other code generated by backend

      dispatch(
        setSelectedFileDataForProUpdateMapping({
          tagName: tagName,
          fileNo: fileNo,
          pageNo: actualPageNumber,
        })
      );
    }

    if (
      isDisabled &&
      (cellToUpdate?.parameterIndex !== null ||
        cellToUpdate?.mappingIndex !== null)
    ) {
      setCellToUpdate({
        parameterIndex: null,
        mappingIndex: null,
      });
    } else if (
      isDisabled &&
      (cellToUpdate?.parameterIndex === null ||
        cellToUpdate?.mappingIndex === null)
    ) {
      setCellToUpdate({
        parameterIndex: null,
        mappingIndex: null,
      });
    } else {
      setCellToUpdate({
        parameterIndex: parameterIndex,
        mappingIndex: mappingIndex,
      });
    }
  };

  // const onClickResetButtonProApiCall = () => {
  //   dispatch(getProDataForReset(localStorage.batchId, localStorage.projectId));

  //   setLogs((prevLogs) => [
  //     ...prevLogs,
  //     logObject({
  //       isActivity: true,
  //       extractionType: "template",
  //       category: "inputs",
  //       action: "Data Reset",
  //     }),
  //   ]);
  // };

  const handleUserPermission = () => {
    callMapData2(actionAndAutoSave);
  };

  const handleEsignDialogBoxClose = () => {
    setOpenSignPad(false);

    setTimeout(() => {
      dispatch(isSignatureUploaded());
    }, 1500);
  };
  // new done
  const handleRowRejection = (parameterIndex, remark) => {
    if (role === "processor") {
      parametersData[parameterIndex].mappings[0] = {
        ...parametersData[parameterIndex].mappings[0],
        processorCellRejection: {
          isRejected: true,
          remark: remark,
          date: moment(new Date()).format("DD-MMM-YYYY"),
          rejectedBy: localStorage?.userName,
        },
      };
      // setProcessorsRejectionCounts((prev) => prev + 1);
    }
    setRejectedCount((prevState) => (prevState >= 0 ? prevState + 1 : 0)); // increament counter used this to toggle api(save / reject) based on rejection in row or cell happened or not
    setParametersData([...parametersData]);

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "free_form",
        category: "dataEntry",
        action: "Rejected",
        parameter: parametersData[parameterIndex]?.query,
        rangeMin: parametersData[parameterIndex]?.range?.["min"],
        rangeMax: parametersData[parameterIndex]?.range?.["max"],
        pageNo: parametersData[parameterIndex].mappings[0]?.pageNo,
        tagName: parametersData[parameterIndex].mappings[0]?.tagName,
        fileNo: parametersData[parameterIndex].mappings[0]?.fileNo,
        // coordinates:
        //   parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
        // coordinatesValues:
        //   parametersData[parameterIndex]?.mappings[mappingIndex]
        //     ?.coordinatesValues,
        dataType: parametersData[parameterIndex]?.dataType,
        value: parametersData[parameterIndex].mappings[0]?.response,
        rowColIndex: [
          parseInt(parameterIndex) + 1,
          // , parseInt(mappingIndex) + 1
        ],
        remark: remark,
        // mbrName: selectedFile?.originalFileName,
        document:
          coordinatesData[
            parseInt(parametersData[parameterIndex]?.mappings[0]?.fileNo)
          ]?.pages[
            parseInt(parametersData[parameterIndex]?.mappings[0]?.pageNo)
          ]?.imageUrl,
        ...(role === "processor"
          ? { processorRejected: true }
          : { validatorRejected: true }),
      }),
    ]);

    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
  };

  // new done
  const deleteRowRejection = (parameterIndex) => {
    if (role === "processor") {
      parametersData[parameterIndex].mappings[0] = {
        ...parametersData[parameterIndex].mappings[0],
        processorCellRejection: {},
      };

      // setProcessorsRejectionCounts((prev) => prev - 1);
    }
    setRejectedCount((prevState) => (prevState > 0 ? prevState - 1 : 0)); // decrement counter used this to toggle api(save / reject) based on rejection in row or cell happened or not
    setParametersData([...parametersData]);

    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "free_form",
        category: "dataEntry",
        action: "Rejection Undone",
        parameter: parametersData[parameterIndex]?.query,
        rowColIndex: [parseInt(parameterIndex) + 1],
      }),
    ]);
  };

  // not done yet
  const markAsResolveRejection = (parameterIndex, index) => {
    // In Pro ROle - mark rejection did by validator
    if (role === "processor") {
      parametersData[parameterIndex].mappings[0].validatorCellRejection = {
        isResolved: true,
        date: moment(new Date()).format("DD-MMM-YYYY"),
        resolvedBy: localStorage?.userName,
        remark:
          parametersData[parameterIndex].mappings[0].validatorCellRejection
            ?.remark,
      };
      setParametersData([...parametersData]);
      // setValidatorsRejectionCounts((prev) => prev - 1);
    }

    // if (role === "preProcessor") {
    //   parametersData[parameterIndex].processorRowRejection = {
    //     isResolved: true,
    //     resolvedDate: moment(new Date()).format("DD-MMM-YYYY"),
    //     resolvedBy: localStorage?.userName,
    //     remark: parametersData[parameterIndex].processorRowRejection?.remark,
    //   };

    //   parametersData[parameterIndex]?.mappings?.forEach((mapping) => {
    //     mapping.reInitiateOcr = true;
    //   });

    //   setParametersData([...parametersData]);
    //   // setProcessorsRejectionCounts((prev) => prev - 1);
    // }
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "free_form",
        category: "dataEntry",
        action: "Rejection Resolved",
        parameter: parametersData[parameterIndex]?.query,
        rowColIndex: [parseInt(parameterIndex) + 1],
      }),
    ]);
  };

  const handleAddQuestion = (newQuestions) => {
    setIsUpdateParameters(true);
    // add new parameter in to old existed parametersData retrived from template

    const existingData = parametersData || [];

    const maxIndex = existingData.reduce(
      (max, item) => Math.max(max, item?.question_index || 0),
      0
    );

    const newData = newQuestions.map((q, i) => ({
      query: q?.question || "",
      isNewAddedByPro: true,
      question_index: maxIndex + i + 1,
      mappings: [
        {
          tagName: "",
          pageNo: "",
          fileNo: "",
          value: "",
          response: "",
        },
      ],
    }));

    setParametersData([...existingData, ...newData]);

    // delete new parameter after added in to table
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    let newQuestionDataInStringFormat = ``;
    newQuestions.forEach((item, index) => {
      newQuestionDataInStringFormat = `${newQuestionDataInStringFormat}${
        index > 0 ? ", " : ""
      }${index + 1}. Question: ${item?.question}`;
    });

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "free_form",
        category: "inputs",
        action: "New Questions Added",
        data: newQuestionDataInStringFormat,
      }),
    ]);
  };

  const handleBlur = (text, parameterIndex, query) => {
    const updatedParametersData = [...parametersData];

    if (updatedParametersData[parameterIndex].query !== text) {
      updatedParametersData[parameterIndex].query = text;

      setParametersData([...updatedParametersData]);

      if (!anyOperationPerformedOnEntirePage.current) {
        anyOperationPerformedOnEntirePage.current = true;
      }

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "free_form",
          category: "dataEntry",
          action: `Question Name Updated`,
          parameter: query,
          value: text,
          rowColIndex: [parseInt(parameterIndex) + 1],
          dataType: updatedParametersData[parameterIndex]?.dataType,
          rangeMin: updatedParametersData[parameterIndex]?.range?.min,
          rangeMax: updatedParametersData[parameterIndex]?.range?.max,
        }),
      ]);
    }
  };

  const addComment = (parameterIndex, commment) => {
    parametersData[parameterIndex].processorComment = commment;
    setParametersData([...parametersData]);
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "free_form",
        category: "dataEntry",
        action: "Comment Added",
        parameter: parametersData[parameterIndex]?.query,
        value: commment,
        rangeMin: parametersData[parameterIndex]?.range?.["min"],
        rangeMax: parametersData[parameterIndex]?.range?.["max"],
        pageNo: parametersData[parameterIndex].mappings[0]?.pageNo,
        tagName: parametersData[parameterIndex].mappings[0]?.tagName,
        fileNo: parametersData[parameterIndex].mappings[0]?.fileNo,
        // coordinates:
        //   parametersData[parameterIndex]?.mappings[0]?.coordinates,
        // coordinatesValues:
        //   parametersData[parameterIndex]?.mappings[0]
        //     ?.coordinatesValues,
        dataType: parametersData[parameterIndex]?.dataType,
        rowColIndex: [parseInt(parameterIndex) + 1],

        // mbrName: selectedFile?.originalFileName,
        document:
          coordinatesData[
            parseInt(parametersData[parameterIndex]?.mappings[0]?.fileNo)
          ]?.pages[
            parseInt(parametersData[parameterIndex]?.mappings[0]?.pageNo)
          ]?.imageUrl,
      }),
    ]);
  };

  const deleteComment = (parameterIndex) => {
    parametersData[parameterIndex].processorComment = "";
    setParametersData([...parametersData]);
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "free_form",
        category: "dataEntry",
        action: "Comment Deleted",
        parameter: parametersData[parameterIndex]?.query,
        value: parametersData[parameterIndex]?.processorComment,
        rowColIndex: [parseInt(parameterIndex) + 1],
      }),
    ]);
  };

  const handleChangeReProcess = ({
    checked,
    parameterData,
    parameterIndex,
  }) => {
    const mapping = parametersData[parameterIndex]?.mappings?.[0];

    if (checked) {
      mapping.reInitiateProVlm = true;
      mapping.proVlmPageNo = selectedFilesDataForProUpdate?.pageNo;
      mapping.proVlmTagName = selectedFilesDataForProUpdate?.tagName;
      mapping.proVlmFileNo = selectedFilesDataForProUpdate?.fileNo;
      //
      // as from ai not getting below values so updating in fe
      // mapping.pageNo = selectedFilesDataForProUpdate?.pageNo;
      mapping.fileNo = selectedFilesDataForProUpdate?.fileNo;
      mapping.tagName = selectedFilesDataForProUpdate?.tagName;
      // end of values

      setParametersData([...parametersData]);
      setReProcessVlmCounts((prevCnt) => prevCnt + 1);

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "free_form",
          category: "dataEntry",
          action: "Cell Re-Processed",
          parameter: parametersData[parameterIndex]?.query,
          rangeMin: parametersData[parameterIndex]?.range?.["min"],
          rangeMax: parametersData[parameterIndex]?.range?.["max"],
          pageNo: selectedFilesDataForProUpdate?.pageNo,
          tagName: selectedFilesDataForProUpdate?.tagName,
          fileNo: selectedFilesDataForProUpdate?.fileNo,
          // coordinates:
          //   parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
          // coordinatesValues:
          //   parametersData[parameterIndex]?.mappings[mappingIndex]
          //     ?.coordinatesValues,
          dataType: parametersData[parameterIndex]?.dataType,
          value: parametersData[parameterIndex].mappings[0]?.response,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            // , parseInt(mappingIndex) + 1
          ],
          // remark: remark,
          //   mbrName: selectedFile?.originalFileName,
          document:
            coordinatesData[
              parseInt(parametersData[parameterIndex]?.mappings[0]?.fileNo)
            ]?.pages[
              parseInt(parametersData[parameterIndex]?.mappings[0]?.pageNo)
            ]?.imageUrl,
          // ...(role === "processor"
          //   ? { processorRejected: true }
          //   : { validatorRejected: true }),
        }),
      ]);
    } else {
      // as from ai not getting below values so updating in fe
      // mapping.pageNo = mapping?.lockedPrePageNo;
      mapping.fileNo = mapping?.lockedPreFileNo;
      mapping.tagName = mapping?.lockedPreTagName;
      // end of values
      delete mapping.reInitiateProVlm;
      delete mapping.proVlmPageNo;
      delete mapping.proVlmTagName;
      delete mapping.proVlmFileNo;
      setParametersData([...parametersData]);
      setReProcessVlmCounts((prevCnt) => prevCnt - 1);
      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "free_form",
          category: "dataEntry",
          action: "Cell Re-Processing Undone",
          parameter: parametersData[parameterIndex]?.query,
          rangeMin: parametersData[parameterIndex]?.range?.["min"],
          rangeMax: parametersData[parameterIndex]?.range?.["max"],
          pageNo: parametersData[parameterIndex].mappings[0]?.proVlmPageNo,
          tagName: parametersData[parameterIndex].mappings[0]?.proVlmTagName,
          fileNo: parametersData[parameterIndex].mappings[0]?.proVlmFileNo,
          // coordinates:
          //   parametersData[parameterIndex]?.mappings[0]?.coordinates,
          // coordinatesValues:
          //   parametersData[parameterIndex]?.mappings[0]
          //     ?.coordinatesValues,
          dataType: parametersData[parameterIndex]?.dataType,
          value: parametersData[parameterIndex].mappings[0]?.value,
          rowColIndex: [parseInt(parameterIndex) + 1],
          // mbrName: selectedFile?.originalFileName,
          document:
            coordinatesData[
              parseInt(parametersData[parameterIndex]?.mappings[0]?.fileNo)
            ]?.pages[
              parseInt(parametersData[parameterIndex]?.mappings[0]?.pageNo)
            ]?.imageUrl,
        }),
      ]);
    }
  };

  const handleResponseChange = (index, value) => {
    if (value === "Yes") {
      handleTrueCheckboxChange(index);
    } else if (value === "No") {
      handleFalseCheckboxChange(index);
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "free_form",
        category: "dataEntry",
        action: "Data Entered",
        parameter: parametersData[index]?.query,
        value: value,
        dataType: parametersData[index]?.dataType,
        rangeMin: parametersData[index]?.range?.["min"],
        rangeMax: parametersData[index]?.range?.["max"],
        // coordinates:
        //   parametersData[index]?.mappings[mappingIndex]?.coordinates,
        // coordinatesValues:
        //   parametersData[index]?.mappings[mappingIndex]
        //     ?.coordinatesValues,
        tagName:
          parametersData[index].mappings[0].tagName ||
          selectedFilesDataForProUpdate?.tagName,
        pageNo:
          parametersData[index].mappings[0].pageNo ||
          selectedFilesDataForProUpdate?.pageNo,
        fileNo:
          parametersData[index].mappings[0].fileNo ||
          selectedFilesDataForProUpdate?.fileNo,
        rowColIndex: [
          parseInt(index) + 1,
          // parseInt(mappingIndex) + 1,
        ],
        mbrName: selectedFilesDataForProUpdate?.originalFileName,

        document:
          coordinatesData[
            parseInt(parametersData[index]?.mappings[0]?.fileNo) ||
              selectedFilesDataForProUpdate?.fileNo
          ]?.pages[
            parseInt(parametersData[index]?.mappings[0]?.pageNo) ||
              selectedFilesDataForProUpdate?.pageNo
          ]?.imageUrl,

        // document:
        //   coordinatesData[parseInt(parametersData[index]?.mappings[0]?.fileNo)]
        //     ?.pages[parseInt(parametersData[index]?.mappings[0]?.pageNo)]
        //     ?.imageUrl,
      }),
    ]);

    // "Not Sure" is disabled, so no action needed for it.
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      setAlert({ ...isAlert, open: false, message: "", title: "" });
    }

    setAlert({ ...isAlert, open: false, message: "", title: "" });
  };

  // const handleChangeValue = (parameterIndex, value) => {
  //   parametersData[parameterIndex].mappings[0].value = value;
  //   setParametersData([...parametersData]);
  // };

  const handleBlurValue = (parameterIndex, value) => {
    if (parametersData[parameterIndex].mappings[0].value !== value) {
      parametersData[parameterIndex].mappings[0].value = value;
      setParametersData([...parametersData]);

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "free_form",
          category: "dataEntry",
          action: "Data Entered",
          parameter: parametersData[parameterIndex]?.query,
          value: value,
          dataType: parametersData[parameterIndex]?.dataType,
          rangeMin: parametersData[parameterIndex]?.range?.["min"],
          rangeMax: parametersData[parameterIndex]?.range?.["max"],
          tagName: parametersData[parameterIndex].mappings[0]?.tagName,
          pageNo: parametersData[parameterIndex].mappings[0]?.pageNo,
          fileNo: parametersData[parameterIndex].mappings[0]?.fileNo,
          // mbrName: selectedFile?.originalFileName,
          document:
            coordinatesData[
              parseInt(parametersData[parameterIndex]?.mappings[0]?.fileNo)
            ]?.pages[
              parseInt(parametersData[parameterIndex]?.mappings[0]?.pageNo)
            ]?.imageUrl,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            // parseInt(mappingIndex) + 1,
          ],
        }),
      ]);

      if (
        parametersData[parameterIndex].mappings[0]?.pageNo === "" &&
        parametersData[parameterIndex].mappings[0]?.tagName === "" &&
        parametersData[parameterIndex].mappings[0]?.value !== ""
      ) {
        parametersData[parameterIndex].mappings[0] = {
          ...parametersData[parameterIndex].mappings[0],
          fileNo: selectedFilesDataForProUpdate?.fileNo,
          pageNo: selectedFilesDataForProUpdate?.pageNo,
          tagName: selectedFilesDataForProUpdate?.tagName,
          lockedPreTagName: selectedFilesDataForProUpdate?.tagName,
          lockedPrePageNo: selectedFilesDataForProUpdate?.pageNo,
          lockedPreFileNo: selectedFilesDataForProUpdate?.fileNo,
          forNoPreProMappingDataEntryByPro: true,
        };

        // for insertion of logs
        setLogs((prevLogs) => [
          ...prevLogs,
          logObject({
            extractionType: "free_form",
            category: "dataEntry",
            action:
              // string === "valueMapping"
              //   ?
              "Mapping added by Processor for unmapped data",
            // : "Add Parameter Key Mapping",
            parameter: parametersData[parameterIndex]?.query,
            dataType: parametersData[parameterIndex]?.dataType,
            rangeMin: parametersData[parameterIndex]?.range?.["min"],
            rangeMax: parametersData[parameterIndex]?.range?.["max"],
            coordinates:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[0]?.coordinates,
            // : parametersData[parameterIndex]?.mappings[0]?.keyData
            //     ?.coordinates,
            coordinatesValues:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[0]?.coordinatesValues,
            // : parametersData[parameterIndex]?.mappings[0]?.keyData
            //     ?.coordinatesValues,

            tagName:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[0]?.tagName,
            // : parametersData[parameterIndex]?.mappings[0]?.keyData
            //     ?.tagName,

            pageNo:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[0]?.pageNo,
            // : parametersData[parameterIndex]?.mappings[0]?.keyData
            //     ?.pageNo,

            fileNo:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[0]?.fileNo,
            // : parametersData[parameterIndex]?.mappings[0]?.keyData
            //     ?.fileNo,

            rowColIndex: [parseInt(parameterIndex) + 1, parseInt(0) + 1],
            // mbrName: selectedFile?.originalFileName || "",
            document:
              coordinatesData[selectedFilesDataForProUpdate?.fileNo]?.pages[
                selectedFilesDataForProUpdate?.pageNo
              ]?.imageUrl,
          }),
        ]);
      }
    }
  };

  const updateParameterQuestion = (question, parameterIndex, mappingIndex) => {
    if (
      parametersData[parameterIndex].mappings[mappingIndex]
        ?.parameter_question !== question
    ) {
      parametersData[parameterIndex].mappings[mappingIndex] = {
        ...parametersData[parameterIndex].mappings[mappingIndex],
        parameter_question: question,
      };
      setParametersData([...parametersData]);

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "template",
          category: "dataEntry",
          action: "Context Updated",
          parameter: parametersData[parameterIndex]?.query,
          rangeMin: parametersData[parameterIndex]?.range?.["min"] || "",
          rangeMax: parametersData[parameterIndex]?.range?.["max"] || "",
          pageNo: parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
          tagName:
            parametersData[parameterIndex].mappings[mappingIndex]?.tagName,
          fileNo: parametersData[parameterIndex].mappings[mappingIndex]?.fileNo,
          coordinates:
            parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
          coordinatesValues:
            parametersData[parameterIndex]?.mappings[mappingIndex]
              ?.coordinatesValues,
          dataType: parametersData[parameterIndex]?.dataType,
          value: parametersData[parameterIndex].mappings[mappingIndex]?.value,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            parseInt(mappingIndex) + 1,
          ],
          remark: question,
          // mbrName: selectedFile?.originalFileName,
          document:
            coordinatesData[
              parseInt(
                parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo
              )
            ]?.pages[
              parseInt(
                parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo
              )
            ]?.imageUrl,
          // ...(role === "processor"
          //   ? { processorRejected: true }
          //   : { validatorRejected: true }),
        }),
      ]);
    }
  };

  const resetOrder = () => {
    if (!Array.isArray(parametersData) || parametersData.length === 0) return;

    const getIndex = (item) =>
      typeof item.question_index === "number"
        ? item.question_index
        : Number.MAX_SAFE_INTEGER;

    const sortedByOriginalIndex = [...parametersData].sort(
      (a, b) => getIndex(a) - getIndex(b)
    );

    setParametersData(sortedByOriginalIndex);
  };

  const isDisableWrapper = (mapping, mappingIndex, parameterIndex) => {
    if (mapping?.isDerivativeField) {
      return true;
    }

    const isDataRejectedByProcessor = false;
    const entireBatchRejectedByPro = false;

    const isDisableFlag = isDisable(
      mapping,
      mappingIndex,
      parameterIndex,
      role,
      isDataRejectedByProcessor,
      entireBatchRejectedByPro,
      parametersData,
      entireBatchRejectedByVali,
      reProcessEntireBatch,
      reProcess,
      isDataRejectedByValidator
      // reValidate
    );
    return isDisableFlag;
  };

  const onHandleChangeDatatype = (dataType, parameter, parameterIndex) => {
    parametersData[parameterIndex].range = { min: "", max: "" };
    parametersData[parameterIndex].dataType = dataType;
    setParametersData([...parametersData]);

    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "qc",
        category: "dataEntry",
        action: "Datatype Added",
        parameter: parametersData[parameterIndex]?.query,
        dataType: dataType,
      }),
    ]);
  };

  const handleRange = (value, parameterIndex, type) => {
    parametersData[parameterIndex].range[type] = value;
    setParametersData([...parametersData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "qc",
        category: "dataEntry",
        action: `${type === "min" ? "Minimum" : "Maximum"} Range Added`,
        parameter: parametersData[parameterIndex]?.query,
        ...(type === "min" ? { rangeMin: value } : { rangeMax: value }),
        rangeMin:
          type === "min" ? value : parametersData[parameterIndex]?.range?.min,
        rangeMax:
          type === "max" ? value : parametersData[parameterIndex]?.range?.max,
        dataType: parametersData[parameterIndex]?.dataType,
      }),
    ]);
  };

  return (
    <Box>
      {showParameterTable === false && (
        <Box>
          <Grid container>
            <Grid
              Item
              md={12}
              // className="addRow-dataMap"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Tabs
                // className="left-aligned-tabs"
                size="small"
                value={0}
                TabIndicatorProps={{
                  style: {
                    marginBottom: "2px", // Adds some space between the indicator and the tab text
                  },
                }}
                sx={{
                  minHeight: "35px", // Set minimum height for the Tabs component
                  height: "38px", // Set fixed height for the Tabs component
                  paddingTop: "5px",
                  paddingLeft: "20px",
                }}
              >
                {/* Parameter Table Tab */}
                <Tab
                  label="QC Table"
                  // className="mapping_toggle_tab"
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "#ffff !important",
                    transition: "background-color 0.3s",
                    minHeight: "20px", // Decrease the height of the tab
                    padding: "5px 10px", // Padding to make it look smaller
                    fontSize: "0.875rem", // Smaller font size
                    borderRadius: "6px",
                  }}
                />
              </Tabs>

              <NewQuestion role={role} handleAddQuestion={handleAddQuestion} />
              {/* Temp commented as api is not working  */}
              {/* <Buttons
                onClick={onClickResetButtonProApiCall}
                className="reset-data"
                text="Reset Data"
                variant="outlined"
                size="small"
              /> */}
            </Grid>
          </Grid>

          <div
          //  style={{ overflow: "scroll" }}
          >
            <Grid
              container
              className={"qc-DataMapTable-wrap"}
              style={{ width: "100%" }}
            >
              <Grid item className="qc-table-row">
                <Item
                  className="qc-DataMap-header qc-table-cell qc-resizable"
                  // className="DataMap-header table-cell resizable"

                  style={{
                    width: columnWidths.sr,
                    justifyContent: "center",
                    alignItems: "center",
                    // position: "sticky !important",
                    // zIndex: "999",
                    display: "flex",
                  }}
                  onMouseDown={handleMouseDown("sr")}
                >
                  <Label text="Sr." />
                </Item>

                <Item
                  className="qc-DataMap-header qc-table-cell qc-resizable"
                  style={{
                    width: columnWidths.parameter,
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    // position: "sticky !important",
                    // zIndex: "999",
                  }}
                  onMouseDown={handleMouseDown("parameter")}
                >
                  <Label text="Parameters" />
                </Item>

                <Item
                  className="datatype-wrap table-cell resizable"
                  style={{
                    width: columnWidths.dataType,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onMouseDown={handleMouseDown("dataType")}
                >
                  <Label text="Data Type">Data Type</Label>
                </Item>

                <Item
                  className="rangeSelect-wrap table-cell resizable"
                  style={{
                    width: columnWidths.range,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onMouseDown={handleMouseDown("range")}
                >
                  <Label text="Range" />
                </Item>

                <Item
                  className="qc-DataMap-header qc-table-cell qc-resizable"
                  style={{
                    width: columnWidths.singleRowInput,
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "4px",
                    textAlign: "center",
                  }}
                  onMouseDown={handleMouseDown("singleRowInput")}
                  onClick={() => handleSort("response")}
                >
                  <div style={{ fontWeight: 500, marginBottom: 4 }}>
                    <Label text="Response" />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    {/* Sort Icon with color */}
                    {sortOrder.column === "response" ? (
                      (() => {
                        const response = sortOrder.order[0]; // current active response
                        const color =
                          response === "Not Sure"
                            ? "#ff9800"
                            : response === "Yes"
                            ? "#4caf50"
                            : response === "No"
                            ? "#f44336"
                            : "gray";

                        return (
                          <ArrowDownwardIcon
                            fontSize="small"
                            style={{ color }}
                          />
                        );
                      })()
                    ) : (
                      <ArrowDownwardIcon fontSize="small" />
                    )}

                    {/* Divider */}
                    <div
                      style={{
                        height: "16px",
                        width: "1px",
                        backgroundColor: "#ccc",
                        margin: "0 4px",
                      }}
                    />

                    {/* Clear Sort Icon Button */}
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        resetOrder();
                        setSortOrder({
                          column: "",
                          order: ["Not Sure", "Yes", "No"],
                        }); // reset sort order state
                      }}
                      size="small"
                      style={{
                        padding: "2px",
                        color:
                          sortOrder.column === "response"
                            ? sortOrder.order[0] === "Not Sure"
                              ? "#ff9800"
                              : sortOrder.order[0] === "Yes"
                              ? "#4caf50"
                              : sortOrder.order[0] === "No"
                              ? "#f44336"
                              : "inherit"
                            : "inherit",
                      }}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </div>
                </Item>

                {/* <Item
                  className={`DataMap-header table-cell resizable`}
                  style={{
                    width: columnWidths.input,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onMouseDown={handleMouseDown("input")}
                  onClick={() => handleSort("yes")}
                >
                  <Label text="Yes" />
                  {sortOrder.column === "yes" &&
                    (sortOrder.direction === "asc" ? (
                      <ArrowUpwardIcon size="small" fontSize="small" />
                    ) : (
                      <ArrowDownwardIcon size="small" fontSize="small" />
                    ))}
                </Item>

                <Item
                  className={`DataMap-header table-cell resizable`}
                  style={{
                    width: columnWidths.input2,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("no")}
                  onMouseDown={handleMouseDown("input2")}
                >
                  <Label text="No" />
                  {sortOrder.column === "no" &&
                    (sortOrder.direction === "asc" ? (
                      <ArrowUpwardIcon size="small" fontSize="small" />
                    ) : (
                      <ArrowDownwardIcon size="small" fontSize="small" />
                    ))}
                </Item>

                <Item
                  className={`DataMap-header table-cell resizable`}
                  style={{
                    width: columnWidths.input7,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("not_sure")}
                  onMouseDown={handleMouseDown("input7")}
                >
                  <Label text="Not Sure" />
                  {sortOrder.column === "not_sure" &&
                    (sortOrder.direction === "asc" ? (
                      <ArrowUpwardIcon size="small" fontSize="small" />
                    ) : (
                      <ArrowDownwardIcon size="small" fontSize="small" />
                    ))}
                </Item> */}

                <Item
                  className={`qc-DataMap-header qc-table-cell qc-resizable`}
                  style={{
                    width: columnWidths.input8,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    display: "flex",
                  }}
                  onMouseDown={handleMouseDown("input8")}
                >
                  <Label text="Value" />
                </Item>

                <Item
                  className={`qc-DataMap-header qc-table-cell qc-resizable`}
                  style={{
                    width: columnWidths.input5,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    display: "flex",
                  }}
                  // onClick={() => handleSort("no")}
                  onMouseDown={handleMouseDown("input5")}
                >
                  <Label text="Comment" />
                </Item>

                {/* Rejection */}
                <Item
                  // className={`qc-DataMap-header qc-table-cell qc-resizable`}
                  className={`last-labels `}
                  style={{
                    width: columnWidths.input3,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    display: "flex",
                    padding: "4px",
                  }}
                  // onClick={() => handleSort("no")}
                  onMouseDown={handleMouseDown("input3")}
                >
                  <Label text="Reject" />
                </Item>

                {reProcess && (
                  <Item
                    className={`last-labels `}
                    // className={`qc-DataMap-header qc-table-cell qc-resizable`}
                    style={{
                      width: columnWidths.input4,
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      display: "flex",
                      padding: "4px",
                    }}
                    // onClick={() => handleSort("no")}
                    onMouseDown={handleMouseDown("input4")}
                  >
                    <Label text="Rejection Note" />
                  </Item>
                )}

                {/* 2nd Checkbox in processor after rejected by vali */}
                {role === "processor" && isDataRejectedByValidator && (
                  <Item
                    // id="Pro-rej"
                    // className={`DataMap-header table-cell resizable `}
                    className={`last-labels `}
                    style={{
                      width: columnWidths.valiRejection,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Label text="Rejected By Validator" padding="0px"></Label>
                  </Item>
                )}

                <Item
                  // className={`DataMap-header table-cell resizable`}
                  className={`last-labels `}
                  style={{
                    width: columnWidths.input6,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    display: "flex",
                    padding: "4px",
                  }}
                  // onClick={() => handleSort("no")}
                  onMouseDown={handleMouseDown("input6")}
                >
                  <Label text="Re-Process" />
                </Item>
              </Grid>

              {parametersData?.map((parameterData, parameterIndex) => (
                <Grid item className="qc-DataMapTable" key={parameterIndex}>
                  <Item style={{ width: columnWidths.sr }}>
                    {parameterIndex + 1}
                  </Item>

                  <Item style={{ width: columnWidths?.parameter }}>
                    <QCEditableCell
                      query={parameterData?.query}
                      parameterIndex={parameterIndex}
                      handleBlur={handleBlur}
                      // onClickCellToRedirect={() =>
                      //   onClickCellToRedirect(parameterData?.mappings[0])
                      // }
                      onClickCellToRedirect={(e) =>
                        onClickCellToRedirect({
                          e,
                          tagName: parameterData?.mappings[0]?.tagName,
                          pageNo: parameterData?.mappings[0]?.pageNo,
                          fileNo: parameterData?.mappings[0]?.fileNo,
                          parameterIndex,
                          mappingIndex: 0,
                          coordinates: parameterData?.mappings[0]?.coordinates,
                          isDisabled: isDisableWrapper(
                            parameterData?.mappings[0],
                            0,
                            parameterIndex
                          ),
                          actualPageNumber:
                            parameterData?.mappings[0]?.actual_page_number,
                        })
                      }
                    />
                    {/* <TextField
                      inputProps={{ readOnly: true }}
                      className="parameters-name"
                      multiline
                      id="standard-basic"
                      variant="standard"
                      value={parameterData?.query}
                      onClick={() =>
                        onClickCellToRedirect(parameterData?.mappings[0])
                      }
                    /> */}
                  </Item>

                  <Item
                    className="datatype-wrap-selector "
                    style={{ width: columnWidths.dataType }}
                  >
                    <DataTypeSelector
                      parameterData={parameterData}
                      onHandleChangeDatatype={onHandleChangeDatatype}
                      parameterIndex={parameterIndex}
                      role={role}
                    />
                  </Item>

                  <Item
                    className="range-selector "
                    style={{ width: columnWidths.range }}
                  >
                    <RangeSelector
                      key={`${parameterIndex}_${parameterData.query}`}
                      handleRange={handleRange}
                      parameterIndex={parameterIndex}
                      dataType={parameterData?.dataType}
                      selectedRange={parameterData?.range}
                      role={role}
                      parameterData={parameterData}
                    />
                  </Item>

                  <Item
                    // className="datatype-wrap"
                    style={{
                      width: columnWidths?.singleRowInput,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      // border: "1px solid #dcdcdc",
                    }}
                    // onMouseEnter={(e) => {
                    //   e.currentTarget.style.boxShadow =
                    //     "0 4px 8px rgba(0, 0, 0, 0.15)";
                    //   e.currentTarget.style.border = "1px solid #a0a0a0";
                    // }}
                    // onMouseLeave={(e) => {
                    //   e.currentTarget.style.boxShadow =
                    //     "0 2px 4px rgba(0, 0, 0, 0.08)";
                    //   e.currentTarget.style.border = "1px solid #dcdcdc";
                    // }}
                  >
                    <FormControl
                    // style={{
                    //   width: "100%",
                    //   display: "flex",
                    //   alignItems: "center", // Ensures all elements align properly
                    //   transition: "border 0.3s ease, box-shadow 0.3s ease",
                    // }}
                    >
                      <Select
                        labelId={`response-select-label-${parameterIndex}`}
                        value={parameterData?.mappings[0]?.response || ""}
                        onChange={(e) =>
                          handleResponseChange(parameterIndex, e.target.value)
                        }
                        displayEmpty
                        // style={{
                        //   display: "flex",
                        //   alignItems: "center", // Aligns text properly
                        //   background: "#fff",
                        //   borderRadius: "8px",
                        //   padding: "8px 40px 8px 12px", // Add padding to the right for the icon
                        //   fontSize: "14px",
                        //   color: "#444",
                        //   position: "relative", // Ensures no overlap
                        // }}
                        IconComponent={(props) => (
                          <ExpandMoreIcon
                            // {...props}
                            style={{
                              color: "#888",
                              // position: "absolute",
                              // right: "12px", // Moves the icon to the far right
                              // pointerEvents: "none", // Prevents interaction with the icon
                            }}
                          />
                        )}
                        // MenuProps={{
                        //   PaperProps: {
                        //     style: {
                        //       maxHeight: 200,
                        //       backgroundColor: "#f7f7f7",
                        //       boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        //     },
                        //   },
                        // }}
                        disabled={
                          parameterData?.mappings[0]?.response !== "Not Sure" &&
                          isDisableWrapper(
                            parameterData?.mappings[0],
                            0,
                            parameterIndex
                          )
                        }
                      >
                        <MenuItem value="" disabled>
                          <em style={{ color: "#aaa" }}>Select Response</em>
                        </MenuItem>
                        <MenuItem
                          value="Yes"
                          style={{
                            color:
                              parameterData?.mappings[0]?.response === "Yes"
                                ? "#4caf50"
                                : "#444",
                          }}
                        >
                          <CheckCircleOutlineIcon
                            style={{
                              color:
                                parameterData?.mappings[0]?.response === "Yes"
                                  ? "#4caf50"
                                  : "#aaa",
                              marginRight: "5px",
                              verticalAlign: "middle",
                            }}
                          />
                          Yes
                        </MenuItem>
                        <MenuItem
                          value="No"
                          style={{
                            color:
                              parameterData?.mappings[0]?.response === "No"
                                ? "#f44336"
                                : "#444",
                          }}
                        >
                          <CancelOutlinedIcon
                            style={{
                              color:
                                parameterData?.mappings[0]?.response === "No"
                                  ? "#f44336"
                                  : "#aaa",
                              marginRight: "5px",
                              verticalAlign: "middle",
                            }}
                          />
                          No
                        </MenuItem>
                        <MenuItem
                          value="Not Sure"
                          style={{
                            color:
                              parameterData?.mappings[0]?.response ===
                              "Not Sure"
                                ? "#ff9800"
                                : "#888",
                          }}
                        >
                          <HelpOutlineIcon
                            style={{
                              color: "#ff9800",
                              marginRight: "5px",
                              verticalAlign: "middle",
                            }}
                          />
                          Not Sure
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Item>

                  <Item
                    className="datatype-wrap"
                    style={{
                      width: columnWidths?.input8,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    sx={
                      role !== "preProcessor" && {
                        ...(Validation(
                          parametersData[parameterIndex]?.dataType,
                          parametersData[parameterIndex]?.range,
                          parameterData?.mappings[0]?.value
                        )?.error && {
                          border: "2px solid!important",
                          borderRadius: "5px!important",
                          borderColor: "#ff9800!important",
                        }),
                      }
                    }
                  >
                    {/* <Label
                      text={parameterData?.mappings[0]?.value}
                      fontSize="16px"
                    /> */}

                    {/* <TextField
                      multiline
                      value={parameterData?.mappings[0]?.value}
                      onChange={(e) =>
                        handleChangeValue(parameterIndex, e.target.value)
                      }
                      onClick={() =>
                        onClickCellToRedirect(parameterData?.mappings[0])
                      }
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        style: {
                          padding: "0px", // Removes inner padding
                        },
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          padding: "0px", // Ensures no extra padding in the field
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: "4px", // Adjust text padding as needed
                        },
                      }}
                    /> */}

                    <ProcessorValueEditableCell
                      parameterIndex={parameterIndex}
                      textValue={parameterData?.mappings[0]?.value}
                      handleBlurValue={handleBlurValue}
                      // onClickCellToRedirect={() =>
                      //   onClickCellToRedirect(parameterData?.mappings[0])
                      // }

                      onClickCellToRedirect={(e) =>
                        onClickCellToRedirect({
                          e,
                          tagName: parameterData?.mappings[0]?.tagName,
                          pageNo: parameterData?.mappings[0]?.pageNo,
                          fileNo: parameterData?.mappings[0]?.fileNo,
                          parameterIndex,
                          mappingIndex: 0,
                          coordinates: parameterData?.mappings[0]?.coordinates,
                          isDisabled: isDisableWrapper(
                            parameterData?.mappings[0],
                            0,
                            parameterIndex
                          ),
                          actualPageNumber:
                            parameterData?.mappings[0]?.actual_page_number,
                        })
                      }
                      parametersData={parametersData}
                      mapping={parameterData?.mappings[0]}
                      mappingIndex={0}
                      // rowRejectionData={rowRejectionData}
                      entireBatchRejectedByVali={entireBatchRejectedByVali}
                      reProcess={reProcess}
                      isDataRejectedByValidator={isDataRejectedByValidator}
                      reProcessEntireBatch={reProcessEntireBatch}
                    />

                    {
                      // role === "preProcessor" &&
                      // (parameterData?.mappings[0]?.processorCellRejection
                      //   ?.isRejected === true ||
                      //   (parameterData?.mappings[0]?.pageNo >= 0 &&
                      //     parameterData?.mappings[0]?.tagName &&
                      //     (parameterData?.mappings[0]?.parameter_question ||
                      //       parameterData?.mappings[0]
                      //         ?.parameter_question === ""))) && (
                      //          ||
                      // role === "processor" ||
                      // role === "validator"
                      <CellMenu
                        parameter_question={
                          parameterData?.mappings[0]?.parameter_question
                        }
                        updateParameterQuestion={(question) =>
                          updateParameterQuestion(question, parameterIndex, 0)
                        }
                        // isRejectedByProcessor={
                        //   parameterData?.mappings[0]?.processorCellRejection
                        //     ?.isRejected
                        // }
                        // processorRejectionRemark={
                        //   parameterData?.mappings[0]?.processorCellRejection
                        //     ?.remark
                        // }
                        // isRejectedByValidator={
                        //   parameterData?.mappings[0]?.validatorCellRejection
                        //     ?.isRejected
                        // }
                        // validatorRejectionRemark={
                        //   parameterData?.mappings[0]?.validatorCellRejection
                        //     ?.remark
                        // }
                        // rejectCell={(rejectionRemark) =>
                        //   rejectCell(
                        //     rejectionRemark,
                        //     parameterIndex,
                        //     mappingIndex
                        //   )
                        // }
                        // deleteRejection={() =>
                        //   deleteRejection(parameterIndex, mappingIndex)
                        // }
                        role={role}
                        // markAsResolveByProcessor={() =>
                        //   markAsResolveByProcessor(
                        //     parameterIndex,
                        //     mappingIndex
                        //   )
                        // }
                        // isRwoValidated={
                        //   parameterData?.rowValidation?.isValidated
                        // }
                        // heading={
                        //   role === "preProcessor"
                        //     ? action.REJECTION_REMARK
                        //     : action.REJECTION_PROMPT
                        // }
                        // isResolvedProcessorCellRejection={
                        //   parameterData?.mappings[0]?.processorCellRejection
                        //     ?.isResolved
                        // }
                        // isResolvedValidatorCellRejection={
                        //   parameterData?.mappings[0]?.validatorCellRejection
                        //     ?.isResolved
                        // }
                        // reInitiateProVlm={
                        //   parameterData?.mappings[0]?.reInitiateProVlm
                        // }
                        // handleChangeReProcess={(type) =>
                        //   handleChangeReProcess(
                        //     type,
                        //     parameterIndex,
                        //     mappingIndex
                        //   )
                        // }
                        // processorsRejectionCounts={
                        //   processorsRejectionCounts
                        // }
                        // reProcessVlmCounts={reProcessVlmCounts}
                        // ref={cellMenuRef} // new for qc context to auto open on mapping
                        showMenuButton={
                          parameterData?.mappings[0]?.processorCellRejection
                            ?.isRejected === true ||
                          (parameterData?.mappings[0]?.pageNo >= 0 &&
                          parameterData?.mappings[0]?.tagName &&
                          (parameterData?.mappings[0]?.parameter_question ||
                            parameterData?.mappings[0]?.parameter_question ===
                              "")
                            ? true
                            : false) ||
                          parameterData?.isNewAddedByPro === true
                        } // new prop as in qc pre we want to assign ref so we need to open bydefault this component
                        isShowDeleteButton={false}
                      />
                      // )
                    }
                  </Item>

                  {/*  Processor Comment */}
                  <Item
                    // className="datatype-wrap"
                    style={{
                      width: columnWidths?.input5,
                      justifyContent: "center",
                    }}
                  >
                    <QCComment
                      comment={parameterData?.processorComment}
                      addComment={addComment}
                      deleteComment={deleteComment}
                      role={role}
                      isReadOnly={false}
                      heading={"Comment"}
                      parameterIndex={parameterIndex}
                    />
                  </Item>

                  <Item
                    className="no-border"
                    // className="datatype-wrap"
                    style={{
                      width: columnWidths?.input3,
                      justifyContent: "center",
                    }}
                  >
                    <QCRowRejectAndReviewNew
                      isFirstCheckbox={true}
                      handleRowRejection={handleRowRejection}
                      parameterData={parameterData}
                      deleteRowRejection={deleteRowRejection}
                      role={role}
                      markAsResolveRejection={markAsResolveRejection}
                      parameterIndex={parameterIndex}
                      heading={"Do you want to reject the row?"}
                      reProcessVlmCounts={reProcessVlmCounts}
                    />
                  </Item>

                  {
                    reProcess && (
                      // parameterData?.mappings[0]?.processorCellRejection?.isResolved && (
                      <Item
                        className="no-border"
                        // className="datatype-wrap"
                        style={{
                          width: columnWidths?.input4,
                          justifyContent: "center",
                          pointerEvents: parameterData?.mappings[0]
                            ?.processorCellRejection?.isResolved
                            ? "auto"
                            : "none",
                          opacity: parameterData?.mappings[0]
                            ?.processorCellRejection?.isResolved
                            ? 1
                            : 0.5,
                        }}
                        disabled
                      >
                        <QCRowRejectAndReviewNew
                          parameterData={parameterData}
                          role={role}
                          parameterIndex={parameterIndex}
                          heading={"View Remark"}
                          disableFooterBtns={true}
                          icon="view"
                        />
                      </Item>
                    )
                    // )
                  }

                  {/* 2nd Checkbox for validator rejections in processor after rejected by vali */}
                  {role === "processor" && isDataRejectedByValidator && (
                    <Item
                      className="no-border"
                      // className="reject-cell"
                      style={{
                        width: columnWidths?.valiRejection,
                        justifyContent: "center",
                      }}
                    >
                      <QCRowRejectAndReviewNew
                        parameterData={parameterData}
                        role={role}
                        isReadOnly={true}
                        isDataRejectedByValidator
                        markAsResolveRejection={markAsResolveRejection}
                        parameterIndex={parameterIndex}
                        heading={"Row Rejection Remark."}
                      />
                    </Item>
                  )}

                  <Item
                    className="no-border"
                    // className="datatype-wrap"
                    style={{
                      width: columnWidths?.input6,
                      justifyContent: "center",
                    }}
                  >
                    <ReInitiateVlmCheckbox
                      handleChangeReProcess={(checked) =>
                        handleChangeReProcess({
                          checked,
                          parameterData,
                          parameterIndex,
                        })
                      }
                      parameterData={parameterData}
                      // disabled={processorsRejectionCounts > 0}
                    />
                  </Item>
                </Grid>
              ))}
            </Grid>
          </div>
        </Box>
      )}
      {openAuth && (
        <Authentication
          openAuth={openAuth}
          handleClose={() => setOpenAuth(false)}
          handleUserPermission={handleUserPermission}
        />
      )}

      {openSignPad && (
        <ModalSign
          openSignPad={openSignPad}
          handleEsignDialogBoxClose={handleEsignDialogBoxClose}
        ></ModalSign>
      )}

      {isAlert?.open && (
        <Snackbar
          open={true}
          autoHideDuration={3000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          key={"topcenter"}
        >
          <Alert onClose={handleClose} className="error-alert" severity="error">
            <AlertTitle color="white">{isAlert?.title}</AlertTitle>
            {isAlert?.message}
          </Alert>
        </Snackbar>
      )}
    </Box>
  );
});
